import React from 'react';
import { Grid } from '@material-ui/core';
import DefaultBanner from '../../../../../assets/DefaultBanner.jpg';
import moment from 'moment';
import { getAllUserAsync } from '../../bccTeenybeansStore/bccTeenybeansStoreSlice';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

function AboutDetails({ styles, data }) {
  const dispatch = useDispatch();

  const { allUsers } = useSelector((state) => {
    const { teenybeansReducer } = state;
    return {
      allUsers: teenybeansReducer.allUser
        ? teenybeansReducer.allUser && teenybeansReducer.allUser.data
        : [],
    };
  });

  React.useEffect(() => {
    if (data && data._id !== '') {
      try {
        dispatch(
          getAllUserAsync({
            params: { schoolId: data._id },
          })
        );
      } catch (error) {
        toast.error('user could not be fetched. Please try again!');
      }
    }
  }, [data]);

  const UserId =
    data &&
    data.schoolAdmins[0] &&
    data.schoolAdmins &&
    data.schoolAdmins[0]._id;
  const userData = allUsers && allUsers.find((y) => y._id === UserId);

  return (
    <div>
      {data ? (
        <Grid item xs={12}>
          <div className={styles.sectionContainer}>
            <div className={styles.section}>
              <div className={styles.imageContainer}>
                <img
                  src={DefaultBanner}
                  alt="banner"
                  className={styles.bannerImage}
                />
              </div>
              <div className={styles.branchTextContainer}>
                <p>School-ID: {data._id}</p>
                <p>{data.name}</p>
              </div>
            </div>
          </div>
          {/* BRANCH DETAILS */}
          <div className={styles.sectionContainer}>
            <div className={styles.section}>
              <div className={styles.subSection}>
                <p className={styles.sectionText}>School details</p>
                <div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Contact no.</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.phone}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Email address</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.email}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Status</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.isActive === true ? 'Active' : 'In-Active'}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Created on</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {moment(data.createdAt).format('DD MMM YYYY')}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Valid till</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {moment(data.expiryDate).format('DD MMM YYYY')}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                </div>
              </div>
            </div>
            <div className={styles.section}>
              <div className={styles.subSection}>
                <p className={styles.sectionText}>Owner details</p>
                <div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Name</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {userData && userData.name}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Email address</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {userData && userData.email}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Phone</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {userData && userData.mobile}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Role</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {userData && userData.role}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>User id</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {userData && userData._id}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.branchDetailsBorderBottom}></div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      ) : null}
    </div>
  );
}

export default AboutDetails;
